import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2, ShieldX } from 'lucide-react';
import axios from 'axios';
import { setAuthToken, setUser } from '../utils/auth';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [denied, setDenied] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const match = (location.hash || '').match(/session_id=([^&]+)/);
      const sessionId = match ? match[1] : null;
      window.history.replaceState(null, '', window.location.pathname);
      if (!sessionId) { navigate('/login', { replace: true }); return; }
      try {
        const r = await axios.post(`${API}/auth/google/session`,
          { session_id: sessionId }, { withCredentials: true });
        setAuthToken(r.data.token);
        setUser(r.data.user);
        navigate('/chat', { replace: true, state: { user: r.data.user } });
      } catch (e) {
        if (e.response?.status === 403) {
          setDenied(e.response?.data?.detail || 'Access is by owner invitation only.');
        } else {
          setDenied('Sign-in failed — try again.');
        }
      }
    };
    run();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="auth-callback">
      <div className="text-center max-w-sm">
        {denied ? (
          <>
            <ShieldX className="w-10 h-10 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Private System</h1>
            <p className="text-sm text-zinc-400 mb-6" data-testid="access-denied-msg">{denied}</p>
            <button onClick={() => navigate('/login', { replace: true })}
              className="px-6 py-2.5 rounded-full bg-white/[0.06] text-white text-sm hover:bg-white/10"
              data-testid="back-to-login-btn">
              Back to login
            </button>
          </>
        ) : (
          <>
            <h1 className="text-4xl font-bold font-mono text-white mb-4">LEE</h1>
            <Loader2 className="w-6 h-6 animate-spin text-amber-400 mx-auto" />
            <p className="text-sm text-zinc-500 mt-3">Verifying your access…</p>
          </>
        )}
      </div>
    </div>
  );
}
